import axios from "./http.js";
class TeamsApi {
  static getTeamDetails() {
    const abortController = new AbortController();
    return {
      async call(id) {
        return axios.get(`/v5/Teams/${id}/details`, {
          signal: abortController.signal
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
}
var stdin_default = TeamsApi;
export {
  stdin_default as default
};
